<template>
  <div class="privacy-box">
    <privacy></privacy>
  </div>
</template>
<script>
import privacy from "@/components/privacy";
export default {
  name: "Home",
  components: {
    privacy
  },
  data () {
    return {
    };
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let lag = this.$route.query.lag
    if (lag == 'th' || lag == 'mk') {
      this.$i18n.locale = lag
    }
  },
  methods: {
  },

}
</script>

